/* Hethara Interactions — cursor tracking, scroll reveal, cart pulse */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ── Scroll reveal ────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.hethara-reveal');
    if (!els.length) return;

    if (reduced) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' },
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ── Product card image pan + cursor badge ────────────────── */
 /* ── Product card image pan + cursor badge ────────────────── */
  function initCardInspection() {
    if (!hasHover || reduced) return;

    var badge = document.createElement('div');
    badge.id = 'h-cursor-badge';
    badge.setAttribute('aria-hidden', 'true');
    
    /* Force Arabic text if URL contains /ar, otherwise use the theme's default */
    var isArabic = window.location.pathname.startsWith('/ar');
    
    if (isArabic) {
      badge.textContent = 'عرض الروتين';
    } else {
      badge.textContent = (window.accessibilityStrings && window.accessibilityStrings.viewRitual) || 'View ritual';
    }
    
    document.body.appendChild(badge);

    var currentCard = null;
    var raf = null;

    document.addEventListener('mousemove', function (e) {
      var card = e.target && e.target.closest && e.target.closest('.card-wrapper');

      /* Card changed — update badge visibility */
      if (card !== currentCard) {
        if (currentCard) badge.classList.remove('is-active');
        currentCard = card;
        if (card) badge.classList.add('is-active');
      }

      if (!card) return;

      /* throttle via rAF */
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rect = card.getBoundingClientRect();
        var mx = (((e.clientX - rect.left) / rect.width) * 100).toFixed(1) + '%';
        var my = (((e.clientY - rect.top) / rect.height) * 100).toFixed(1) + '%';
        card.style.setProperty('--mx', mx);
        card.style.setProperty('--my', my);
        badge.style.left = e.clientX + 'px';
        badge.style.top = e.clientY + 'px';
      });
    });

    /* Hide badge when mouse leaves the window */
    document.addEventListener('mouseleave', function () {
      currentCard = null;
      badge.classList.remove('is-active');
    });
  }

  /* ── Slider drag-to-scroll (desktop mouse; touch already native) ── */
  function initSliderDrag() {
    if (!hasHover) return;
    var sliders = document.querySelectorAll('.slider--everywhere, .hethara-testimonials__viewport');

    sliders.forEach(function (slider) {
      var dragging = false,
        moved = false,
        startX = 0,
        startScroll = 0;

      slider.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = slider.scrollLeft;
        slider.classList.add('is-dragging');
      });

      slider.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        slider.scrollLeft = startScroll - dx;
      });

      function stopDrag() {
        dragging = false;
        slider.classList.remove('is-dragging');
      }
      slider.addEventListener('pointerup', stopDrag);
      slider.addEventListener('pointerleave', stopDrag);

      /* Swallow the click that follows a drag so it doesn't open links/video */
      slider.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true,
      );
    });
  }

  /* ── Testimonials marquee: auto-drift, pause on hover/drag/video ── */
  function initTestimonialMarquee() {
    var viewports = document.querySelectorAll('.hethara-testimonials__viewport');
    if (!viewports.length) return;

    viewports.forEach(function (viewport) {
      if (reduced || !hasHover) {
        viewport.classList.add('hethara-testimonials__viewport--static');
        return;
      }

      var track = viewport.querySelector('.hethara-testimonials__track');
      var wrapper = viewport.closest('.page-width') || viewport.parentElement;
      var speed = parseFloat(viewport.dataset.speed) || 40; /* px/sec */
      var hovering = false;
      var videoHold = false;
      var userPaused = false;
      var last = null;

      viewport.addEventListener('mouseenter', function () {
        hovering = true;
      });
      viewport.addEventListener('mouseleave', function () {
        hovering = false;
      });

      /* WCAG 2.2.2: auto-moving content needs a way to pause it. */
      var toggle = wrapper && wrapper.querySelector('.hethara-testimonials__toggle');
      if (toggle) {
        toggle.addEventListener('click', function () {
          userPaused = !userPaused;
          toggle.classList.toggle('is-paused', userPaused);
          toggle.setAttribute('aria-pressed', String(userPaused));
          toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        });
      }

      /* A tap on a play button holds the pause; native <video> pause/ended
         (captured, since those events don't bubble) releases it once nothing
         else in the track is still playing. Embedded YouTube/Vimeo iframes
         report their own pause/finish via postMessage. */
      viewport.addEventListener('click', function (e) {
        if (e.target.closest('.hethara-testimonial__play')) videoHold = true;
      });

      track.addEventListener(
        'pause',
        function () {
          var stillPlaying = Array.prototype.some.call(track.querySelectorAll('video'), function (v) {
            return !v.paused && !v.ended;
          });
          if (!stillPlaying) videoHold = false;
        },
        true,
      );
      track.addEventListener(
        'ended',
        function () {
          videoHold = false;
        },
        true,
      );

      window.addEventListener('message', function (e) {
        var data = e.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (err) {
            return;
          }
        }
        if (!data) return;
        var ytPaused = data.event === 'onStateChange' && (data.info === 2 || data.info === 0);
        var vimeoPaused = data.event === 'pause' || data.event === 'finish';
        if (ytPaused || vimeoPaused) videoHold = false;
      });

      function tick(now) {
        if (last === null) last = now;
        var dt = now - last;
        last = now;

        if (!hovering && !videoHold && !userPaused && !viewport.classList.contains('is-dragging')) {
          viewport.scrollLeft += (speed * dt) / 1000;
          var half = track.scrollWidth / 2;
          if (viewport.scrollLeft >= half) viewport.scrollLeft -= half;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      /* Static-mode prev/next controls are hidden via CSS in drift mode, but
         wire them anyway in case the viewport switches (e.g. orientation). */
      var prevBtn = wrapper && wrapper.querySelector('.slider-button--prev');
      var nextBtn = wrapper && wrapper.querySelector('.slider-button--next');
      var counter = wrapper && wrapper.querySelector('.slider-counter--current');
      var total = track.querySelectorAll('.hethara-testimonial:not([aria-hidden])').length;
      var index = 1;

      function scrollByCard(dir) {
        var card = track.querySelector('.hethara-testimonial');
        var step = card ? card.getBoundingClientRect().width + 32 : 300;
        viewport.scrollBy({ left: dir * step, behavior: 'smooth' });
        index = ((index - 1 + dir + total) % total) + 1;
        if (counter) counter.textContent = index;
      }

      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          scrollByCard(-1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          scrollByCard(1);
        });
    });
  }

  /* ── Cart count pulse ───────────────────────────────── */
  function initCartPulse() {
    if (reduced) return;
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    new MutationObserver(function () {
      bubble.classList.remove('h-cart-pulse');
      /* Force reflow so re-adding the class re-triggers the animation */
      void bubble.offsetWidth;
      bubble.classList.add('h-cart-pulse');
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* ── Re-init reveals on theme editor section load ───────────── */
  document.addEventListener('shopify:section:load', initReveal);

  /* ── Boot ───────────────────────────────────────── */
  function boot() {
    initReveal();
    initCardInspection();
    initSliderDrag();
    initTestimonialMarquee();
    initCartPulse();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
